import React from "react";

interface MissingTokenIconProps {
  size: string;
}

const MissingTokenIcon = (props: MissingTokenIconProps) => {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="-6 -2 35 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Icons-/-Line-/-Other-Coins"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M20,15.217 L20,20.652 C20,23.052 16.642,25 12.5,25 C8.358,25 5,23.053 5,20.652 L5,19.317"
          id="Path"
          stroke="#000000"
          strokeWidth="1.5"
        ></path>
        <path
          d="M18.355,12.5 C19.384,13.244 20,14.189 20,15.217 C20,17.617 16.642,19.5650264 12.5,19.5650264 C11.6604915,19.5667255 10.8229396,19.4839753 10,19.318"
          id="Path"
          stroke="#000000"
          strokeWidth="1.5"
        ></path>
        <path
          d="M0,9.783 L0,15.217 C0,17.617 3.358,19.565 7.5,19.565 C11.642,19.565 15,17.619 15,15.217 L15,13.883"
          id="Path"
          stroke="#000000"
          strokeWidth="1.5"
        ></path>
        <path
          d="M10,13.883 C9.17707544,14.049076 8.33951339,14.1318271 7.5,14.1300296 C3.358,14.1300296 0,12.184 0,9.783 C0,7.89 2.087,6.283 5,5.683"
          id="Path"
          stroke="#000000"
          strokeWidth="1.5"
        ></path>
        <path
          d="M5,4.348 L5,9.783 C5,12.183 8.358,14.13 12.5,14.13 C16.642,14.13 20,12.184 20,9.783 L20,4.348"
          id="Path"
          stroke="#000000"
          strokeWidth="1.5"
        ></path>
        <ellipse
          id="Oval"
          stroke="#000000"
          strokeWidth="1.5"
          cx="12.5"
          cy="4.348"
          rx="7.5"
          ry="4.348"
        ></ellipse>
      </g>
    </svg>
  );
};

export default MissingTokenIcon;
